import image1 from '../../../../../../assets/image/home_carousel-2.svg';
import image2 from '../../../../../../assets/image/empty-state-5.png';
import styles from './EmptyState.module.scss';

type EmptyStateProps = {
  type?: 'NO_DATA' | 'PENDING';
};

export const EmptyState = ({ type = 'NO_DATA' }: EmptyStateProps) => {
  return (
    <div className={styles.container}>
      {type === 'NO_DATA' ? (
        <>
          <h5 className={styles.title}>Configure seu painel de aderência de preços.</h5>
          <p className={styles.subtitle}>Se você for o administrador da conta, configure a aderência de preços no Modo Administrador.</p>
          <p className={styles.subtitle}>Caso não seja, entre em contato com o administrador para concluir o processo.</p>
          <img src={image1} alt="" />
        </>
      ) : (
        <>
          <h5 className={styles.title}>Aguarde a atualização.</h5>
          <p className={styles.subtitle}>Amanhã você já pode começar a usar seu painel!</p>
          <img src={image2} alt="" />
        </>
      )}
    </div>
  );
};
